import { render, staticRenderFns } from "./biometricVerification.vue?vue&type=template&id=7506af28&scoped=true"
import script from "./biometricVerification.vue?vue&type=script&lang=js"
export * from "./biometricVerification.vue?vue&type=script&lang=js"
import style0 from "./biometricVerification.vue?vue&type=style&index=0&id=7506af28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506af28",
  null
  
)

export default component.exports